import { render, staticRenderFns } from "./TextEditorTinyCoupon.vue?vue&type=template&id=3d2c5626&scoped=true&"
import script from "./TextEditorTinyCoupon.vue?vue&type=script&lang=js&"
export * from "./TextEditorTinyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorTinyCoupon.vue?vue&type=style&index=0&id=3d2c5626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2c5626",
  null
  
)

export default component.exports